// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var RowOrientation;
(function (RowOrientation) {
    RowOrientation[RowOrientation["Horizontal"] = 0] = "Horizontal";
    RowOrientation[RowOrientation["Vertical"] = 1] = "Vertical";
})(RowOrientation || (RowOrientation = {}));
